export default __webpack_public_path__ + "static/media/Madeeha_Khan_Yousafzai_AHV_In_Moms_We_Trust.daad11a9.jpg";